import { AppraisersActionsButton } from '../components/AppraisersActionsButton';

export const onActionCellRender = (e, inactive) => {
    return (
        <AppraisersActionsButton
            data={e.data}
            inactive={inactive}
        />
    );
};
